import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_ZOOM } from '../selectors/map';

const initialState = {
  stopMarkerPopup: null,
  zoomLevel: [DEFAULT_ZOOM],
  bounds: null,
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setStopMarkerPopup(state, action) {
      state.stopMarkerPopup = action.payload;
    },
    setZoomLevel(state, action) {
      state.zoomLevel = action.payload;
    },
    setMapBounds(state, action) {
      state.bounds = action.payload;
    },
  },
});

export const { setStopMarkerPopup, setZoomLevel, setMapBounds } =
  mapSlice.actions;

export default mapSlice.reducer;
